import React from "react";
import { BookOpen } from "lucide-react";

const TOGETHER_IMG =
  "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/v7e44kbi_IMG-20260420-WA0007.jpg";

export default function Transmission() {
  return (
    <section
      data-testid="transmission-section"
      className="bg-[#F2EBE1] py-24 lg:py-36"
    >
      <div className="max-w-[1200px] mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative aspect-[5/6] overflow-hidden">
            <img
              src={TOGETHER_IMG}
              alt="Femmes réunies – transmission intergénérationnelle"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#C5A059]/60 pointer-events-none" />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <p className="sdm-divider">Transmission intergénérationnelle</p>
          <h2 className="font-serif-display text-4xl lg:text-5xl text-[#4A192C] mt-8 leading-tight">
            Des douleurs partagées,
            <br />
            <em className="text-[#C5A059]">des sagesses transmises.</em>
          </h2>
          <p className="mt-6 text-[#2C1E23]/85 leading-relaxed text-lg">
            Les mères qui ont traversé la nuit offrent, à celles qui arrivent,
            le pont qu&apos;elles ont elles-mêmes construit. Un rite de
            passage puissant, où la parole circule, se transforme, et fait
            école.
          </p>

          <div className="mt-10 bg-[#FAF7F2] border border-[#4A192C]/15 p-8 lg:p-10">
            <div className="flex items-start gap-4">
              <BookOpen className="w-8 h-8 text-[#C5A059] mt-1 shrink-0" />
              <div>
                <h3 className="font-serif-display text-2xl text-[#4A192C]">
                  Les Reines de Paris
                </h3>
                <p className="mt-2 text-[#2C1E23]/80">
                  Un livre collectif de témoignages anonymes et illustrés,
                  célébrant la force des femmes qui, de l&apos;ombre, ont
                  choisi la lumière.
                </p>
                <span className="inline-block mt-4 text-[0.68rem] tracking-[0.22em] uppercase text-[#C5A059] font-medium">
                  Ouvrage à paraître
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
